import { ISocialProfileResponse, Meta } from "../types";

export const apiGetFooterSocialLinks = (): Promise<ITeamMembersResponse> => {
  return fetch("/data/socials.json").then((r) => r.json());
};

export interface ITeamMembersResponse extends ISocialProfileResponse {
  meta: Meta;
}
